import React from 'react';
import { Link } from 'react-router-dom';

import Navbar from '../../components/navbar/Navbar';
import styles from './home.module.scss';

const Home = () => {
  return (
    <>
      <Navbar />
      <header className={styles.homeHeader}>
        <div className={styles.textWrapper}>
          <h1 className={styles.heading1}>Some catchy heading</h1>
          <h3 className={styles.heading3}>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do
            eiusmod tempor incididunt ut labore et dolore magna aliqua.
          </h3>
        </div>
        <div className={styles.btnWrapper}>
          <Link to="/register" className={styles.btn}>
            For developers
          </Link>
          <Link to="/register" className={styles.btn}>
            For employers
          </Link>
        </div>
      </header>
      <main className={styles.main}>
        <section className={styles.customers}>
          <h2 className={styles.customers_title}>Some of our customers</h2>
          <div className={styles.logosWrapper}>
            <img
              className={styles.logosWrapper_netflix}
              src={require('../../assets/images/netflix.png')}
              alt=""
            />
            <img
              className={styles.logosWrapper_meta}
              src={require('../../assets/images/meta.png')}
              alt=""
            />
            <img
              className={styles.logosWrapper_spotify}
              src={require('../../assets/images/spotify.png')}
              alt=""
            />
          </div>
        </section>
        <section className={styles.whyUsWrapper}>
          <h2 className={styles.whyUsWrapper_title}>Why us?</h2>
          <div className={styles.cardWrapper}>
            <div className={styles.card}>
              <div className={styles.circle}>
                <img
                  className={styles.circle_icon}
                  src={require('../../assets/images/home-card-icon.png')}
                  alt=""
                />
              </div>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTextWrapper_heading}>
                  Major companies
                </h3>
                <p className={styles.cardTextWrapper_text}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.circle}>
                <img
                  className={styles.circle_icon}
                  src={require('../../assets/images/home-card-icon.png')}
                  alt=""
                />
              </div>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTextWrapper_heading}>
                  Major companies
                </h3>
                <p className={styles.cardTextWrapper_text}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </p>
              </div>
            </div>
            <div className={styles.card}>
              <div className={styles.circle}>
                <img
                  className={styles.circle_icon}
                  src={require('../../assets/images/home-card-icon.png')}
                  alt=""
                />
              </div>
              <div className={styles.cardTextWrapper}>
                <h3 className={styles.cardTextWrapper_heading}>
                  Major companies
                </h3>
                <p className={styles.cardTextWrapper_text}>
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed
                  do eiusmod tempor incididunt.
                </p>
              </div>
            </div>
          </div>
        </section>
        <section className={styles.theHowWrapper}>
          <h2 className={styles.theHowWrapper_heading}>The "how"</h2>
          <div className={styles.howCard}>
            <div className={styles.howCard_text}>
              <h3 className={styles.howCard_text_heading}>1.</h3>
              <p className={styles.howCard_text_subHeading}>Create a profile</p>
              <p className={styles.howCard_text_body}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad vero
                ducimus, animi corporis quos exercitationem quas saepe
                voluptates dolorum libero optio necessitatibus.
              </p>
            </div>
            <img
              className={styles.howCard_img}
              src={require('../../assets/images/placeholder-img.png')}
              alt=""
            />
          </div>
          <div className={styles.howCard}>
            <div className={styles.howCard_text}>
              <h3 className={styles.howCard_text_heading}>2.</h3>
              <p className={styles.howCard_text_subHeading}>
                Browse and apply for jobs
              </p>
              <p className={styles.howCard_text_body}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad vero
                ducimus, animi corporis quos exercitationem quas saepe
                voluptates dolorum libero optio necessitatibus.
              </p>
            </div>
            <img
              className={styles.howCard_img}
              src={require('../../assets/images/placeholder-img.png')}
              alt=""
            />
          </div>
          <div className={styles.howCard}>
            <div className={styles.howCard_text}>
              <h3 className={styles.howCard_text_heading}>3.</h3>
              <p className={styles.howCard_text_subHeading}>
                Sit back and get contacted
              </p>
              <p className={styles.howCard_text_body}>
                Lorem ipsum dolor sit amet consectetur adipisicing elit. Ad vero
                ducimus, animi corporis quos exercitationem quas saepe
                voluptates dolorum libero optio necessitatibus.
              </p>
            </div>
            <img
              className={styles.howCard_img}
              src={require('../../assets/images/placeholder-img.png')}
              alt=""
            />
          </div>
        </section>
        <div className={styles.wrapper}>
          <section className={styles.metricsWrapper}>
            <div className={`${styles.metric} ${styles.metric1}`}>
              <h3 className={styles.metric_heading}>2500+</h3>
              <p className={styles.metric_subHeading}>Developers</p>
              <p className={styles.metric_body}>have joined us</p>
            </div>
            <div className={`${styles.metric} ${styles.metric2}`}>
              <h3 className={styles.metric_heading}>30+</h3>
              <p className={styles.metric_subHeading}>Developers</p>
              <p className={styles.metric_body}>hired every month</p>
            </div>
            <div className={`${styles.metric} ${styles.metric3}`}>
              <h3 className={styles.metric_heading}>100+</h3>
              <p className={styles.metric_subHeading}>Companies</p>
              <p className={styles.metric_body}>are looking for talents</p>
            </div>
          </section>
        </div>
        <section className={styles.ctaSection}>
          <div className={styles.textWrapper}>
            <h2 className={styles.textWrapper_heading}>
              Find your golden deal
            </h2>
            <p className={styles.textWrapper_subHeading}>
              Join our community, be surrounded by like-minded.
            </p>
            <p className={styles.textWrapper_body}>
              Sign up below to find new job opportunities and recieve weekly
              list of suitable positions.
            </p>

            <Link to="register" className={styles.cta}>
              Get started
            </Link>
          </div>
        </section>
      </main>
    </>
  );
};

export default Home;
